export enum AccountTypeIdEnum {
  DefinedContribution = 1,
  VariableBenefit = 3,
  MonthlyPension = 4,
  Retirement = 5, // TODO: This account ID is temporary and should be updated when the correct ID is available
  Clearing = 6,
  TransferredIn = 17
}

export const DEFINED_CONTRIBUTION_ACCOUNT_TYPE_IDS = [
  AccountTypeIdEnum.DefinedContribution,
  AccountTypeIdEnum.TransferredIn
];
